import { UserInviteRevokedDtoModelType } from '../../../models';
import getAppRoot from '../../../utils/getAppRoot';

export default ({ store, inviteUuid }: UserInviteRevokedDtoModelType) => () => {
  const rootStore = getAppRoot(store);
  const userInviteDtos = rootStore.model.userInviteDtos;
  for (const [id, invite] of userInviteDtos.entries()) {
    if (invite.uuid === inviteUuid) {
      userInviteDtos.delete(id);
      break;
    }
  }
};
